import { Record } from "immutable";

class FundSellTarget extends Record({ id: null, type: null, msg: null }) {}

export default Object.freeze({
    SWITCH: new FundSellTarget({ id: "SWITCH", msg: "common.fund" }),
    SELL: new FundSellTarget({ id: "SELL", type: "DEBIT", msg: "common.account" }),
});
